// extracted by mini-css-extract-plugin
export default {"form":"style_form__txEL9","title":"style_title__J50di","secondTitle":"style_secondTitle__nqywX","clickHere":"style_clickHere__MnpxR","login":"style_login__FkpNz"};